import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'hx-announce-bar',
  standalone: true,
  imports: [RouterLink],
  template: `
    <a routerLink="/promotions" class="announce-bar">
      <span class="announce-bar-badge">New</span>
      <span class="announce-bar-text">
        Refer a business to Hexacorp and get rewarded when their project kicks off
      </span>
      <span class="announce-bar-cta">View referral program →</span>
    </a>
  `,
})
export class AnnounceBarComponent {}
